export const CART_STATUS_OPEN = 1;
export const CART_STATUS_PROCESSING = 2;
export const CART_STATUS_FINISHED = 3;
export const CART_STATUS_ON_HOLD = 4;
export const CART_STATUS_BLOCKED = 5;
export const ERROR_CART_NOT_FOUND = 'cart_not_found'